export const YoutubeIcon = ({ size = 30 }) => (
  <svg
    width={size * 1.4}
    height={size}
    viewBox="0 0 42 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.1206 4.70664C40.8828 3.79833 40.4196 2.97599 39.7802 2.32705C39.1228 1.65815 38.3171 1.17967 37.439 0.936769C34.153 0.00929123 20.9878 0.00929144 20.9878 0.00929144C15.4993 -0.0575757 10.0122 0.236523 4.55747 0.889927C3.67942 1.15077 2.87518 1.63994 2.21628 2.31393C1.56887 2.98097 1.09993 3.80352 0.854965 4.70477C0.266507 8.09942 -0.0194063 11.5463 0.00107993 14.9988C-0.0199172 18.4483 0.265294 21.894 0.854965 25.2929C1.09468 26.1904 1.56187 27.0092 2.21103 27.6706C2.8602 28.332 3.66859 28.8098 4.55747 29.0628C7.88727 29.9884 20.9878 29.9884 20.9878 29.9884C26.4832 30.0553 31.9773 29.7612 37.439 29.1077C38.3171 28.8648 39.1228 28.3864 39.7802 27.7175C40.4276 27.056 40.8878 26.2335 41.1188 25.3379C41.7226 21.9445 42.0162 18.4963 41.9954 15.0419C42.0408 11.573 41.7476 8.10845 41.1206 4.70477V4.70664ZM16.8023 21.4144V8.58518L27.7558 15.0007L16.8023 21.4144Z"
      fill="black"
    />
  </svg>
);
